import { render } from "./TemplateModal.vue?vue&type=template&id=f0a7ef5e"
import script from "./TemplateModal.vue?vue&type=script&lang=js"
export * from "./TemplateModal.vue?vue&type=script&lang=js"

import "./TemplateModal.vue?vue&type=style&index=0&id=f0a7ef5e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__